import { CheckCircle } from 'lucide-react';
import { useTranslation } from '@/contexts/LanguageContext';

export function VerifiedBadge({ size = 'sm' }) {
  const { tc } = useTranslation('common');
  const sizes = {
    xs: 'text-[10px] px-1.5 py-0.5 gap-0.5',
    sm: 'text-xs px-2 py-0.5 gap-1',
    md: 'text-sm px-2.5 py-1 gap-1.5',
  };
  const iconSizes = { xs: 'w-2.5 h-2.5', sm: 'w-3 h-3', md: 'w-3.5 h-3.5' };

  return (
    <span
      className={`inline-flex items-center font-semibold rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200 ${sizes[size]}`}
      data-testid="verified-badge"
    >
      <CheckCircle className={iconSizes[size]} />
      {tc('verified')}
    </span>
  );
}
